import React from 'react';
import { StandardRow } from 'components/utility/General';
import { SizableText, useTheme } from 'tamagui';
import { styled, createSwitch, Stack } from 'tamagui';

// TODO separate into two interfaces?

const Frame = styled(Stack, {
  width: 40,
  height: 20,
  borderRadius: 20,
  hoverStyle: { opacity: 0.5 },
  variants: {
    checked: {
      true: {
        backgroundColor: '$pred200',
      },
      false: {
        backgroundColor: '$muted300',
      },
    },
  } as const,
  defaultVariants: {
    checked: false,
  },
});

const Thumb = styled(Stack, {
  width: 20,
  height: 20,
  backgroundColor: 'black',
  borderRadius: 20,

  variants: {
    checked: {
      true: {
        opacity: 0.8,
      },
      false: {
        opacity: 0.5,
      },
    },
  } as const,
});

export const Switch = createSwitch({
  Frame,
  Thumb,
});

export interface ISwitch {
  toggle(): void;
  checked: boolean;
  text?: string;
  children?: any;
}

export const RedSwitch = (props: ISwitch) => {
  const size = '$3xl';
  return (
    <Switch
      focusStyle={{ outline: 'none' }}
      bg={'$pred200'}
      size={size}
      onCheckedChange={props.toggle}
      checked={props.checked}
    >
      <Switch.Thumb size={size} animation="bouncy" bg="$pred500" />
    </Switch>
  );
};

export const SettingsSwitch = (props: ISwitch) => {
  const theme = useTheme();
  return (
    <StandardRow p={8}>
      <SizableText color={theme.mainColor.get()}>{props.text}</SizableText>
      <RedSwitch toggle={props.toggle} checked={props.checked} />
    </StandardRow>
  );
};
